import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useProviderAuth } from '@/contexts/ProviderAuthContext';
import { Button } from '@/components/ui/button';
import { LayoutDashboard, LogOut } from 'lucide-react';

export function ProviderLayout({ children }) {
  const location = useLocation();
  const navigate = useNavigate();
  const { provider, logout } = useProviderAuth();
  const path = location.pathname;

  return (
    <div className="min-h-screen bg-slate-50" data-testid="provider-layout">
      <aside className="hidden lg:flex w-64 bg-white border-r border-slate-200 h-screen fixed left-0 top-0 flex-col">
        <div className="p-6 border-b border-slate-100">
          <div className="flex items-center gap-3">
            <img src="/lyfsync-logo.png" alt="LYFSYNC logo" className="w-12 h-12 object-contain" data-testid="provider-brand-logo" />
            <div>
              <h1 className="font-bold text-slate-900">LYFSYNC</h1>
              <p className="text-xs text-slate-500">Provider Console</p>
            </div>
          </div>
        </div>

        <nav className="flex-1 p-4 space-y-1 overflow-y-auto">
          <Link
            to="/provider/dashboard"
            className={path === '/provider/dashboard'
              ? 'flex items-center gap-3 px-4 py-2.5 rounded-lg bg-blue-50 text-blue-900 font-medium'
              : 'flex items-center gap-3 px-4 py-2.5 rounded-lg text-slate-600 hover:bg-slate-100'}
            data-testid="provider-nav-dashboard"
          >
            <LayoutDashboard className="w-5 h-5" />Dashboard
          </Link>
        </nav>

        <div className="p-4 border-t border-slate-100">
          <div className="flex items-center gap-3 px-4 py-3 bg-slate-50 rounded-lg mb-3" data-testid="provider-user-card">
            <div className="w-9 h-9 bg-blue-100 rounded-full flex items-center justify-center">
              <span className="text-blue-900 font-semibold text-sm">{provider?.full_name ? provider.full_name[0] : 'P'}</span>
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium text-slate-900 truncate" data-testid="provider-user-name">{provider?.full_name || 'Provider'}</p>
              <p className="text-xs text-slate-500 truncate" data-testid="provider-user-email">{provider?.email || ''}</p>
            </div>
          </div>
          <Button
            variant="ghost"
            className="w-full justify-start text-red-600 hover:bg-red-50"
            onClick={() => { logout(); navigate('/'); }}
            data-testid="provider-logout-btn"
          >
            <LogOut className="w-4 h-4 mr-2" />Logout
          </Button>
        </div>
      </aside>

      <main className="lg:ml-64 min-h-screen">
        <div className="p-4 md:p-6 lg:p-8">{children}</div>
      </main>
    </div>
  );
}